import React from 'react';
import {
  SaveButton,
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView,
  Query,
  ReferenceArrayInput
} from 'react-admin';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import { Grid } from '@material-ui/core/';
import { find } from 'lodash';

import GridInputFilter from '../../core/components/inputs/GridInputFilter';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import GroupCategoryApi from '../../core/apis/GroupCategoryApi';
import { getIcError } from '../../core/providers/utils';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  fullWidth: {
    width: '100%'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  }
});

const validateSubcategories = (value, allValues, props, field) => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Subcategory must be selected';
  }
  return undefined;
};

class GroupSubcategoryCreate extends React.Component {
  groupSubcategoryFormProps;

  state = {
    submitting: false
  };

  setGroupSubcategoryFormProps = props => {
    this.groupSubcategoryFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.groupSubcategoryFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.groupSubcategoryFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      refreshView
    } = this.props;

    this.setState({ submitting: true });

    // Prepare the list of groupsubcategories to create
    const groupsubcategories = [];
    values.subcategoryIds.forEach(subcategoryId => {
      groupsubcategories.push({
        groupId: values.groupId,
        categoryOrSubcategoryId: subcategoryId
      });
    });

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();

    GroupCategoryApi.create(groupsubcategories)
      .then(() => {
        refreshView();
        handleDialogToggle();
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.groupSubcategoryFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const {
      classes,
      showDialog,
      groupId,
      isDisplayAdminCategoriesOn
    } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`Create Group Subcategory`}
        maxWidth="sm"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          Add Existing Subcategory to Group
        </DialogTitleWithCloseButton>
        <DialogContent>
          <CustomSimpleForm
            initialValues={{
              subcategories: [],
              groupId
            }}
            toolbar={null}
            resource="groupcategories"
            save={this.handleSubmit}
            className={classes.form}
            variant="standard"
            margin="normal"
          >
            <FormSpy>
              {props => {
                this.setGroupSubcategoryFormProps(props);
                return (
                  <Grid container spacing={1}>
                    <Grid item sm={12}>
                      <Query
                        type="GET_MANY_REFERENCE"
                        resource="groupcategories"
                        payload={{
                          target: 'groupId',
                          id: groupId,
                          sort: {},
                          filter: isDisplayAdminCategoriesOn
                            ? undefined
                            : { subType: 'REPORTING' }
                        }}
                      >
                        {({ data, total, loading, error }) => {
                          if (!loading && !error) {
                            const filter = choices => {
                              return choices.filter(
                                item =>
                                  find(data, [
                                    'categoryOrSubcategoryId',
                                    item.id
                                  ]) === undefined
                              );
                            };
                            const categoryIds = [];
                            data.forEach(groupcategory => {
                              if (
                                groupcategory.categoryOrSubcategoryId < 10000
                              ) {
                                categoryIds.push(
                                  groupcategory.categoryOrSubcategoryId
                                );
                              }
                            });
                            return (
                              <ReferenceArrayInput
                                label="To add Subcategory to this Group, select one or multiple items from the list of the Subcategories below."
                                optionTextLabel="Subcategory Name"
                                optionValueLabel="Subcategory ID"
                                resource="subcategories"
                                reference="subcategories"
                                source="subcategoryIds"
                                validate={[validateSubcategories]}
                                perPage={-1}
                                filter={{
                                  categoryId: `[${categoryIds}]`,
                                  orphanVisibility: 'ALL_VISIBLE'
                                }}
                              >
                                <GridInputFilter filter={filter} />
                              </ReferenceArrayInput>
                            );
                          } else {
                            return <></>;
                          }
                        }}
                      </Query>
                    </Grid>
                  </Grid>
                );
              }}
            </FormSpy>
          </CustomSimpleForm>
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label="Add"
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(GroupSubcategoryCreate));
